import type { Appearance } from "@stripe/stripe-js";

const getStripeElementsAppearance = (
	resolvedTheme: string | undefined,
): Appearance => {
	const theme =
		resolvedTheme === "dark"
			? "night"
			: resolvedTheme === "system" &&
					window.matchMedia("(prefers-color-scheme: dark)").matches
				? "night"
				: "stripe";

	return {
		theme,

		variables: {
			borderRadius: "0.5rem",
			colorPrimary: "#0ea5e9",

			colorBackground: theme === "night" ? "#334155" : "#fff",
		},
	};
};

export default getStripeElementsAppearance;
